import PreTripInspectionCheckCalendar from "../../components/Safety/PreTripInspectionCheck/PreTripInspectionCheckCalendar";

const PreTripInspectionCheckPage = () => {
  return <PreTripInspectionCheckCalendar />;
};

export default PreTripInspectionCheckPage;